__turbopack_context__.v({
  "button": "NavbarBackToCompanyDashboard-module-scss-module__MFy2jG__button",
  "hasPreOrderCheckout": "NavbarBackToCompanyDashboard-module-scss-module__MFy2jG__hasPreOrderCheckout",
  "outletDetailsPage": "NavbarBackToCompanyDashboard-module-scss-module__MFy2jG__outletDetailsPage",
});
